import { render } from "./ModalCreateUpdatePromotion.vue?vue&type=template&id=99bfc152&scoped=true"
import script from "./ModalCreateUpdatePromotion.vue?vue&type=script&lang=js"
export * from "./ModalCreateUpdatePromotion.vue?vue&type=script&lang=js"

import "./ModalCreateUpdatePromotion.vue?vue&type=style&index=0&id=99bfc152&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99bfc152"]])

export default __exports__